<div class="info-message">
  <div class="text-container">
    <img [src]="data.icon" class="icon" alt="" />
    <div class="text">
      {{ data.text }}
    </div>
  </div>
</div>
